import { TagsSortOrder } from '../../typings/tags/tagsSortOrder';
import DropdownButton from '../dropdown/dropdownButton';
import DropdownRadioGroupButton from '../dropdown/dropdownRadioGroupButton';
import { Icons } from 'copyright-clearance-center-common-ui';
import { useEffect, useRef, useState } from 'react';

export interface ISortDropdownProps {
	onSortOrderChange: (sort: TagsSortOrder) => void;
	sortOrder: TagsSortOrder;
}

const SortDropdown: React.FunctionComponent<ISortDropdownProps> = props => {
	const [sort, setSort] = useState(props.sortOrder);
	const hasMountedRef = useRef(false);

	useEffect(() => {
		if (hasMountedRef.current) {
			props.onSortOrderChange(sort);
		}

		hasMountedRef.current = true;
	}, [sort]);

	return (
		<DropdownButton className="rup-btn--sm rup-btn--text" text={localize('Sort')} iconBeforeText={Icons.SortIcon}>
			<DropdownRadioGroupButton
				onSelect={() => {
					setSort(TagsSortOrder.ByFrequency);
				}}
				label={localize('Sort by frequency')}
				checkIcon={Icons.CheckMarkIcon}
				selected={sort === TagsSortOrder.ByFrequency}
			/>
			<DropdownRadioGroupButton
				onSelect={() => {
					setSort(TagsSortOrder.Alphabetically);
				}}
				label={localize('Sort alphabetically')}
				checkIcon={Icons.CheckMarkIcon}
				selected={sort === TagsSortOrder.Alphabetically}
			/>
		</DropdownButton>
	);
};

export default SortDropdown;
